import createNotification from './createNotification';
import utility from './utility';

const accountPasswordChange = {
    init: function() {
    const changePasswordButton = document.querySelector("#account--reset-password-edit");
        if (changePasswordButton) {
            changePasswordButton.onclick = () => {
                utility.showPopup(document.querySelector("#account--reset-password-popup"));
            };
        }

        const changePasswordForm = document.querySelector("#account--change-password-form");
        if (changePasswordForm) {
            changePasswordForm.onsubmit = () => {
                this.requestChangePassword();
                return false;
            };
        }
    },

    requestChangePassword: function() {
        const ajaxOptions = {
            url: "/api/web/account/update-password",
            method: "POST",
            data: utility.getFormData(document.querySelector("#account--change-password-form")),
            success: function(e) {
                const result = JSON.parse(e.target.responseText);
                const form = document.querySelector("#account--change-password-form");
                utility.removeFormInputErrors(form);

                if (result.resultCode === "S") {
                    utility.hidePopups();
                    [...form.querySelectorAll("input[type=password]")].map(input => { input.value = null; });
                    createNotification("Your password has been updated");
                }
                else if (result.resultCode === "L") {
                    utility.showNotificationPopup({
                        title: "Change Password Failed",
                        content: result.fieldError.Error,
                        hideCloseIcon: true,
                        button: {
                            text: "OK",
                            url: "/"
                        }
                    });
                }
                else {
                    utility.addFormInputError(form, result.fieldError.Name, result.fieldError.Error);
                }
            },
            always: function() {
                utility.enableButton(document.querySelector("#account--change-password-form button[type=submit]"));
            }
        };
        utility.disableButton(document.querySelector("#account--change-password-form button[type=submit]"));
        utility.ajaxRequest(ajaxOptions);
    }
};

export default accountPasswordChange;


// WEBPACK FOOTER //
// ./assets/src/js/classes/accountPasswordChange.js